import { render, staticRenderFns } from "./PayrollDeductionROI.vue?vue&type=template&id=272c0f17&scoped=true"
import script from "./PayrollDeductionROI.vue?vue&type=script&lang=js"
export * from "./PayrollDeductionROI.vue?vue&type=script&lang=js"
import style0 from "./PayrollDeductionROI.vue?vue&type=style&index=0&id=272c0f17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c0f17",
  null
  
)

export default component.exports